/* Head West preview behavior, on top of aad.js:
   - product videos stored as links in image descriptions: the still shows until the shopper presses play, then the player
     loads with its own controls; stopping (another slide, scrolling away) puts the still back;
   - Previous/Next and a counter for galleries with many photos (they press the neighbouring thumbnail, so aad.js stays in charge);
   - a sold-out variant switches the reassurance panel to its informational wording;
   - related products: the shop's best sellers stand in when Shopify has no recommendations, never showing the current product. */
(function () {
  const reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* One player per slide and one playing at a time. The poster button is hidden while its player shows (see hw.css:
     the theme's display rule would otherwise override the hidden attribute and let a second press add a second player). */
  function stopOthers(keep) {
    document.querySelectorAll('[data-aad-slide]').forEach(s => {
      if (s === keep) return;
      if (s.querySelector('iframe[data-hw-video], video.hw-player')) reset(s);
      s.querySelectorAll('video').forEach(v => { if (!v.paused) v.pause(); });
    });
  }
  function play(btn) {
    const slide = btn.closest('[data-aad-slide]'), kind = btn.dataset.hwVideo, src = btn.dataset.src;
    if (!slide || !src) return;
    const have = slide.querySelector('iframe[data-hw-video], video.hw-player');
    if (have) { stopOthers(slide); if (have.play) have.play().catch(() => {}); return; }
    stopOthers(slide);
    let el;
    if (kind === 'mp4') {
      el = document.createElement('video');
      el.src = src; el.controls = true; el.playsInline = true; el.autoplay = true; el.className = 'aad-pg__video hw-player';
      el.setAttribute('aria-label', btn.dataset.title + ', product video');
      el.addEventListener('play', () => stopOthers(slide));
    } else {
      el = document.createElement('iframe');
      el.className = 'aad-pg__frame';
      el.title = btn.dataset.title + ', product video';
      el.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
      el.setAttribute('allowfullscreen', '');
      el.src = kind === 'vimeo'
        ? 'https://player.vimeo.com/video/' + encodeURIComponent(src) + '?autoplay=1'
        : 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(src) + '?autoplay=1&rel=0&playsinline=1&modestbranding=1';
      el.dataset.hwVideo = '1';
    }
    btn.hidden = true;
    slide.appendChild(el);
    if (el.focus) el.focus({ preventScroll: true });
  }
  function reset(slide) {
    slide.querySelectorAll('iframe[data-hw-video], video.hw-player').forEach(n => n.remove());
    const btn = slide.querySelector('.hw-vplay'); if (btn) btn.hidden = false;
  }
  document.addEventListener('click', e => {
    const b = e.target.closest && e.target.closest('.hw-vplay');
    if (b) { play(b); return; }
    /* A video thumbnail selects its slide (aad.js) and starts that video in the main view: the shopper asked for it. */
    const t = e.target.closest && e.target.closest('[data-aad-pg-thumb].aad-pg__thumb--video');
    if (t) {
      const slide = t.closest('[data-aad-pg]').querySelector('[data-aad-slide][data-media="' + t.dataset.media + '"]');
      const pb = slide && slide.querySelector('.hw-vplay');
      if (pb) play(pb);
      else { const v = slide && slide.querySelector('video'); if (v) { stopOthers(slide); v.play().catch(() => {}); } }
    }
  });
  document.addEventListener('hw:stop', e => { const s = e.target.closest && e.target.closest('[data-aad-slide]'); if (s) reset(s); });

  /* ---------- gallery bar ---------- */
  function initBar(g) {
    const bar = g.querySelector('[data-hw-pg-bar]'); if (!bar) return;
    const thumbs = () => Array.from(g.querySelectorAll('[data-aad-pg-thumb]')).filter(t => !t.hidden);
    const count = bar.querySelector('[data-hw-pg-count]');
    const prev = bar.querySelector('[data-hw-pg="prev"]'), next = bar.querySelector('[data-hw-pg="next"]');
    const at = () => thumbs().findIndex(t => t.getAttribute('aria-current') === 'true');
    function update() {
      const list = thumbs(), i = at();
      count.textContent = (i + 1) + ' of ' + list.length;
      prev.disabled = i <= 0;
      next.disabled = i >= list.length - 1;
    }
    prev.addEventListener('click', () => { const l = thumbs(), i = at(); if (i > 0) l[i - 1].click(); });
    next.addEventListener('click', () => { const l = thumbs(), i = at(); if (i < l.length - 1) l[i + 1].click(); });
    new MutationObserver(update).observe(g, { subtree: true, attributes: true, attributeFilter: ['aria-current', 'hidden'] });
    update();
  }

  /* ---------- sold-out variant: the add button tells us ---------- */
  function initSoldOut(root) {
    const btn = root.querySelector('.aad-buyform [data-aad-add]'); if (!btn) return;
    const set = () => root.classList.toggle('hw-soldout', btn.disabled);
    new MutationObserver(set).observe(btn, { attributes: true, attributeFilter: ['disabled'] });
    set();
  }

  /* ---------- related products: drop the current product, keep four ---------- */
  function trimRelated() {
    document.querySelectorAll('[data-aad-related-load]').forEach(box => {
      const here = location.pathname.replace(/^.*\/products\//, '/products/');
      box.querySelectorAll('li').forEach(li => { const a = li.querySelector('a[href]'); if (a && new URL(a.href, location.href).pathname === here) li.remove(); });
      box.querySelectorAll('li').forEach((li, i) => { if (i >= 4) li.remove(); });
    });
  }
  new MutationObserver(trimRelated).observe(document.documentElement, { childList: true, subtree: true });

  function boot() {
    document.querySelectorAll('[data-aad-pg]').forEach(initBar);
    document.querySelectorAll('[data-aad-pdp]').forEach(initSoldOut);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* Cart drawer: closing it (Continue shopping, the X, Escape or a tap outside) leaves the page where it was. Dawn returns
   focus to whatever opened the drawer, and when that is the header's cart icon the page would jump to the top. */
if (window.customElements) customElements.whenDefined('cart-drawer').then(() => {
  const Drawer = customElements.get('cart-drawer'), close = Drawer.prototype.close;
  Drawer.prototype.close = function () {
    const y = window.scrollY;
    close.apply(this, arguments);
    requestAnimationFrame(() => { if (Math.abs(window.scrollY - y) > 1) window.scrollTo(0, y); });
  };
});
